module.exports = __webpack_public_path__ + "img/Neuron_Logo_Black.bae56702.png";